import IGatewayAPIRequest from "../../types/interfaces/IGatewayAPIRequest";

/**
 * Converts a gateway API request object to the format used by LLMGateway
 *
 * @param {IGatewayAPIRequest} request - The input gateway API request object to be converted.
 *
 * @return {Object} - The converted request object with selected properties.
 */
export default function convertGatewayRequest(request: IGatewayAPIRequest) {
  const convertedRequest: any = {
    messages: request.messages,
    model: request.model,
    rag: request.rag,
    stream: request.stream,
  };
  
  // Add top_k if present
  if (request.top_k !== undefined) {
    convertedRequest.top_k = request.top_k;
  }
  // For backward compatibility, also check rag_options
  else if (request.rag_options && request.rag_options.top_k !== undefined) {
    convertedRequest.top_k = request.rag_options.top_k;
  }

  // Add RAG-specific fields if present
  if (request.include_chunks !== undefined) {
    convertedRequest.include_chunks = request.include_chunks;
  }
  if (request.chunks !== undefined) {
    convertedRequest.chunks = request.chunks;
  }
  if (request.rag_template !== undefined) {
    convertedRequest.rag_template = request.rag_template;
  }
  if (request.include_metadata !== undefined) {
    convertedRequest.include_metadata = request.include_metadata;
  }
  if (request.include_scores !== undefined) {
    convertedRequest.include_scores = request.include_scores;
  }
  
  // Explicitly remove reuse_chunks if present
  if ('reuse_chunks' in convertedRequest) {
    delete convertedRequest.reuse_chunks;
  }
  
  return convertedRequest;
}
